/* eslint-disable no-unused-expressions */
import React from "react";
import "react-awesome-lightbox/build/style.css";
import {
  Badge,
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

export default function TaskBadges(row) {
    const types = {
      "File (photo)": "success",
      Rate: "warning",
      Comment: "info",
      "Yes/No": "primary",
      Quantity: "danger",
    };
    return row.map((input, key) => (
      <Badge key={key} variant={types[input] || "danger"} className="p-2 mx-1">
        {input || "null"}
      </Badge>
    ));
  }